import { BaseModel, convertToArrayModels, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import ArticleFilterOption from './ArticleFilterOption'
import ArticleFilterValue from './ArticleFilterValue'

export default class ArticleFilterGroup extends BaseModel {
  static override constructorName = 'ArticleFilterGroup'

  options: ArticleFilterOption[] = []
  values: ArticleFilterValue[] = []

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      this.options = convertToArrayModels(data.options, ArticleFilterOption)
      this.values = convertToArrayModels(data.values, ArticleFilterValue)
    }
  }
}

registerModel(ArticleFilterGroup)
